













import Vue from 'vue';
import repository from './account-repository';
import { Account } from '../types';
import AccountType from './AccountType';
import AccountLogo from './logo/AccountLogo.vue';

interface Data {
  account: Account|null,
}

export default Vue.extend({
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      account: null,
    };
  },
  watch: {
    id: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    isClient(): boolean {
      if (!this.account) return false;
      return (this.account.type === AccountType.CLIENT);
    },
  },
  methods: {
    load(): void {
      const task = repository.find(this.id);
      task.then((account: Account) => {
        this.account = account;
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    AccountLogo,
  },
});
